import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {Messages} from "../../../../Messages";
import {dismissFlowSuccess} from "../../../../widget/misc/WidgetUtils";
import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {HappyFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {userService} from "../../../../../client/connection/services/UserService.js";
import {SubscriptionCoveragePerk} from "../subscribe/components/CoverageDescriptionElements";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {iFrameState} from "../../../../services/IFrameState";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {PromptManageAccountButton} from "../../../panel-elements/LoginFooter.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {SubscriptionOfferStore} from "../../../../../client/state/SubscriptionOfferStore.js";
import {startSubscriptionFlow} from "../../../flows/FlowEntrypoint.js";
import {BackButton} from "../../../../../core/ui/LinkButton.jsx";


export class DonationSuccessPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        marginBottom: 14,
        textAlign: "center",
        display: "block"
    };

    @styleRule
    message = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(DonationSuccessPanelStyle)
export class DonationSuccessPanel extends BasePanelPage {
    getMessageTop() {
        const donation = iFrameUserDataService.getLatestDonation();
        const merchantName = iFrameMerchantService.getMerchant().getName();
        const email = userService.getUserEmail();

        if (donation.isRecurring()) {
            return Messages.donateThankYouMessageRecurring(merchantName, email)
        }
        return Messages.donateThankYouMessageOneTime(merchantName, email);
    }

    getMessageTitle() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (donation.isRecurring()) {
            return Messages.donateThankYouTitleRecurring(donation.formatPrice());
        }
        return Messages.donateThankYouTitleOneTime(donation.formatPrice());
    }

    getGuidelines() {
        const donation = iFrameUserDataService.getLatestDonation();

        // TODO @params cleanup here
        if (iFrameState.forceHideWallet) {
            return null;
        }

        const guidelines = donation.isRecurring() ? [
            Messages.donateThankYouRecurringGuideline1,
            Messages.donateThankYouRecurringGuideline2
        ] : [
            Messages.donateThankYouOneTimeGuideline1,
            Messages.donateThankYouOneTimeGuideline2,
        ]

        return [
            <div className={this.styleSheet.message}>
                {Messages.donateThankYouBottomMessage}
            </div>,
            guidelines.map(text => <SubscriptionCoveragePerk text={text}/>)
        ];
    }

    renderCrossSellNudge() {
        if (!iFrameState.iframeParams.onSuccessCrossSell) {
            // TODO This should be what we're nudging towards
            return null;
        }

        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        const subscriptionOffers = SubscriptionOfferStore.all();
        if (activeSubscription || subscriptionOffers.length === 0) {
            return null;
        }

        const {styleSheet} = this;

        const enterSubscribeFlow = () => startSubscriptionFlow(false, true); // SkipCTA mode

        return [
            <MessageElement
                className={styleSheet.message}
                style={{fontSize: 24, marginTop: 16, marginBottom: 16}}
                message="Before you go, we have a special offer just for you."
            />,

            <MessageElement
                className={styleSheet.message}
                message="As a token of our appreciation, we invite you to become a TNR member for 50% off. A discounted membership includes exclusive content and unlimited digital access—we also have plans that include a print subscription. Will you join our membership program?"
            />,

            <BlinkButton className={styleSheet.actionButton} onClick={enterSubscribeFlow}>
                Yes, I want to learn more!
            </BlinkButton>,

            <BackButton
                onClick={dismissFlowSuccess}
                label="No, thanks"
            />,
        ]
    }

    render() {
        const {styleSheet} = this;

        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <HappyFaceIcon size={62} className={styleSheet.icon}/>,
            <MessageElement
                className={styleSheet.title}
                message={this.getMessageTitle()}
            />,
            <MessageElement
                className={styleSheet.message}
                message={this.getMessageTop()}
            />,

            this.renderCrossSellNudge() || [
                this.getGuidelines(),
                <BlinkButton className={styleSheet.actionButton} onClick={dismissFlowSuccess}>
                    {Messages.ok}
                </BlinkButton>,
            ],

            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <PromptManageAccountButton className={styleSheet.backButton} />,
        ];
    }
}
